export default __webpack_public_path__ + "static/media/queryimage.cc83bb14.PNG";